import { render } from "./ProductProposal.vue?vue&type=template&id=3ae36a89&scoped=true"
import script from "./ProductProposal.vue?vue&type=script&lang=js"
export * from "./ProductProposal.vue?vue&type=script&lang=js"

import "./ProductProposal.vue?vue&type=style&index=0&id=3ae36a89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae36a89"]])

export default __exports__